import PropTypes from "prop-types";
import React from "react";

const CompetingHoldsCard = ({ hold }) => {
  const c = hold.competing;
  return (
    <div className="d2-card hd-detail-card">
      <div className="d2-card-header"><h3 className="d2-card-title">Competing holds</h3></div>
      {c ? (
        <div className="hd-comp">
          <div className="hd-comp-row"><span>Event</span><strong>{c.name}</strong></div>
          <div className="hd-comp-row"><span>Their hold position</span><strong>{`H${c.position}`}</strong></div>
          {c.genre && <div className="hd-comp-row"><span>Genre</span><strong>{c.genre}</strong></div>}
        </div>
      ) : (
        <div className="hd-empty">
          <div className="hd-empty-title">No competing holds</div>
          <div className="hd-empty-sub">You are the only hold on this date. Confirming now locks the room.</div>
        </div>
      )}
    </div>
  );
};

CompetingHoldsCard.propTypes = { hold: PropTypes.object.isRequired };
export default CompetingHoldsCard;
